export type MapStyleType = 'streets' | 'satellite' | 'hybrid';

export interface StyleButtonDef {
  label: string;
  style: MapStyleType;
}

export const STYLE_BUTTON_DEFS: StyleButtonDef[] = [
  { label: 'Map',       style: 'streets' },
  { label: 'Satellite', style: 'hybrid'  },
];

export function createOverlayContainer(): HTMLDivElement {
  const overlay = document.createElement('div');
  Object.assign(overlay.style, {
    position:       'absolute',
    top:            '10px',
    left:           '10px',
    display:        'flex',
    flexDirection:  'row',
    background:     'rgba(255, 255, 255, 0.95)',
    borderRadius:   '20px',
    padding:        '4px',
    boxShadow:      '0 2px 10px rgba(0, 0, 0, 0.15)',
    backdropFilter: 'blur(10px)',
    zIndex:         '9999',
    fontFamily:     'inherit',
    boxSizing:      'border-box',
    pointerEvents:  'all',
  } as Partial<CSSStyleDeclaration>);
  return overlay;
}

export function applyOverlayBtnStyle(btn: HTMLButtonElement, active: boolean): void {
  Object.assign(btn.style, {
    background:   active ? '#007bff'  : 'transparent',
    color:        active ? '#ffffff'  : '#666666',
    border:       'none',
    borderRadius: '16px',
    padding:      '8px 16px',
    cursor:       'pointer',
    fontSize:     '12px',
    fontWeight:   '500',
    minWidth:     '60px',
    transition:   'background 0.2s, color 0.2s',
    boxShadow:    active ? '0 2px 8px rgba(0, 123, 255, 0.3)' : 'none',
  } as Partial<CSSStyleDeclaration>);
}

export function mountStyleOverlay(
  container:    HTMLElement,
  currentStyle: MapStyleType,
  onSwitch:     (style: MapStyleType) => void
): HTMLDivElement {
  const overlay = createOverlayContainer();

  const state = { currentStyle };
  (overlay as any).__styleState = state;

  STYLE_BUTTON_DEFS.forEach(({ label, style }) => {
    const btn = document.createElement('button');
    btn.textContent      = label;
    btn.dataset['style'] = style;
    applyOverlayBtnStyle(btn, style === state.currentStyle);

    btn.addEventListener('click', () => onSwitch(style));
    btn.addEventListener('mouseenter', () => {
      if (btn.dataset['style'] !== state.currentStyle) {
        btn.style.background = 'rgba(0, 123, 255, 0.1)';
        btn.style.color      = '#007bff';
      }
    });
    btn.addEventListener('mouseleave', () =>
      applyOverlayBtnStyle(btn, btn.dataset['style'] === state.currentStyle)
    );

    overlay.appendChild(btn);
  });

  container.appendChild(overlay);
  return overlay;
}

export function syncOverlayButtons(overlay: HTMLElement, currentStyle: MapStyleType): void {
  const state = (overlay as any).__styleState;
  if (state) state.currentStyle = currentStyle;

  overlay.querySelectorAll<HTMLButtonElement>('button').forEach(btn =>
    applyOverlayBtnStyle(btn, btn.dataset['style'] === currentStyle)
  );
}

export function applyFullscreenDimensions(
  wrapper:     HTMLElement,
  entering:    boolean,
  normalHeight: string = '400px'
): void {
  const mapEl = wrapper.querySelector<HTMLElement>('.map');

  wrapper.style.width  = entering ? '100vw' : '';
  wrapper.style.height = entering ? '100vh' : normalHeight;

  if (mapEl) {
    mapEl.style.width        = entering ? '100vw' : '';
    mapEl.style.height       = entering ? '100vh' : '';
    mapEl.style.borderRadius = entering ? '0'     : '';
  }
}